// Which feature flags mock mode grants the mock account (feature-flag-registry).
//
// Mock mode answers `GET /api/auth/profile` from a fixture, and the mock account
// appears in no flag's `beta` list, so without this every gate resolves false
// under `npm run dev:user` — a flag-gated screen is then unreachable in exactly
// the mode meant for building the portal without a backend, and reads as broken
// rather than as withheld.
//
// The default stays EMPTY deliberately: mock mode must not grant a flag the
// registry never gave that account. This is the opt-in, not a changed default.
//
// Its own module because `apiService.ts` imports `openapi-fetch`, which is
// ESM-only and untransformed by CRA's jest — anything importing it cannot be
// unit tested here.
export function parseMockFlags(value: string | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map(key => key.trim())
    // An empty value splits to [''], which would put a flag whose key is the
    // empty string into the list: false for every real key, but enough to make
    // `flags` non-empty for anything that checks length rather than membership.
    .filter(Boolean);
}
